import { StateStructure } from "@ptl/state";
import { ENROLLMENT_FLOW } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum";
import { IndividualMarketStateStructure } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure";
import { SpecialEnrollmentCircumstanceStateStructure } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/special-enrollment-circumstance.StateStructure.interface";
import { PlanDetailsStateStructure } from "src/app/angular-elements/plan-selection/configs/interfaces/planDetailsStateStructure.interface";
import { PlansStateStructure } from "src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface";
import { EffectiveDateStateStructure } from "src/app/angular-elements/shared/components/configs/interfaces/effective-date.state-structure.interface";
import { LifeEventStateStructure } from "src/app/angular-elements/shared/components/configs/interfaces/life-event.state-structure.interface";
import { EnrollmentAppStateStructure } from "src/app/angular-elements/shared/interfaces/enrollmentAppStateStructure.interface";
import { SEP_CIRCUMSTANCE_ID } from "src/app/angular-elements/shared/interfaces/special-enrollment-circumstances.interface";
import { ZipCountyStateStructure } from "src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface";

/**
 * Reflects the data we store when passing to backend, which we'll later retrieve for use in repopulating the UI
 */
export interface SaveQuoteDataLockedInStateStructure extends StateStructure {
    appStates: {
      effectiveDate: EffectiveDateStateStructure
    },
    componentStates: {
        enrollmentApp: EnrollmentAppStateStructure;
        Plans: PlansStateStructure;
        PlanDetails: PlanDetailsStateStructure;
        ZipCounty: ZipCountyStateStructure;
        LifeEvent?: LifeEventStateStructure;
    };
    payloadStates: {
        individualMarket?: IndividualMarketStateStructure; // could save before this exists
        "special-enrollment-circumstance"?: SpecialEnrollmentCircumstanceStateStructure; // could save in flows where this never exists
    }
}

// Simply defined list with expansion, useful for bundling various URLs associated with a saved quote
export interface SaveQuoteDataUrls {
  [key: "returnUrl" | "saveForConsumerDocumentUploadPageUrl" | string]: string;
}

export enum SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS {
  STEP_0_SAVED = "PRE_PRODUCER_REQUESTED", // reflects the initial save
  STEP_1_REQUESTED = "PRODUCER_REQUESTED", // reflects the send to consumer
  STEP_2_COMPLETED = "CONSUMER_COMPLETED" // reflects the consumer uploaded
}
// Passed along with saved application and returned as-is on retrieval ( good for passing custom data requirements )
export interface SaveQuoteMetaData {
  urls: SaveQuoteDataUrls;
  enrollmentFlow: ENROLLMENT_FLOW;
  state: SaveQuoteDataLockedInStateStructure,
  actionList?: {
    documentUpload?: {
      status: SAVE_QUOTE_DOCUMENT_UPLOAD_HANDOFF_STATUS;
    }; // SXEANG - all actionlist items must be true, to consider "ready to submit" state
  }
}

// Pass to the Save Quote Modal to config the subsequent request
export interface SaveQuoteModalArgs {
  urls: SaveQuoteDataUrls,
  enrollmentFlow: ENROLLMENT_FLOW;
}

export const SEP_FAMILY_HOUSEHOLD_CHANGE_EVENTS: string[] = [
  SEP_CIRCUMSTANCE_ID.BIRTH, 
  SEP_CIRCUMSTANCE_ID.ADOPTION,
  SEP_CIRCUMSTANCE_ID.FOSTER_CARE,
  SEP_CIRCUMSTANCE_ID.COURT_ORDER
]